export const CLICK_THROUGH_LINK = 'url'
export const MEDIA_WIDTH = 'width_pixels'
export const MEDIA_HEIGHT = 'height_pixels'
export const CREATIVE_TYPE_VIDEO = 'CREATIVE_TYPE_VIDEO'

// ad creatives
export const AD_CREATIVES = 'ad_creatives'
export const NAME = 'name'
export const THIRD_PARTY_TAG = 'third_party_tag'
export const VAST_TAG_URL = 'vast_tag_url'

export const formatAdLink = linkValue => {
  return [
    {
      type: 'EXIT_EVENT_TYPE_DEFAULT',
      [CLICK_THROUGH_LINK]: linkValue,
      name: 'clickTag',
      reporting_name: 'clickTag'
    }
  ]
}
